import React from "react";

import { appConstants } from "../../config/app-constants";

type Props = {};

const GrossSalary171Hint: React.FC<Props> = (props: Props) => {
	return (
		<>
			<section className="text-center">
				<h5 className="text-start">
					The below Form 16 shows the salary per 17(1), 17(2) and 17(3). Gross Salary is the sum of
					17(1), 17(2) and 17(3).
				</h5>

				<img
					src={`${appConstants.basePath}/assets/images/hints/gross-salary-17-one.png`}
					alt="salary"
					className="img-fluid d-block mx-auto my-4"
				/>
			</section>
		</>
	);
};

export default GrossSalary171Hint;
